// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"e8fe57bd","266":"5c03f094","333":"b8fd6dbc","562":"665a7656","787":"fe1f1e2a"}[chunkId] + ".chunk.js";
};